import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import dashboardReducer from './dashboardSlice';
import partsReducer from './partsSlice';
import purchaseOrderReducer from './purchaseOrderSlice';
import workOrderReducer from './workOrderSlice';
import routeCardReducer from './routeCardSlice';
import packingListReducer from './packingListSlice';
import bomReducer from './bomSlice';
import productReducer from './productSlice';
import componentReducer from './componentSlice';
import ncrReducer from './ncrSlice';
import toolFixtureReducer from './toolFixtureSlice';
import toolTypeReducer from './toolTypeSlice';
import { adminReducer } from './adminSlice';
import { operationsReducer } from './operationsSlice';
import { workInstructionsReducer } from './workInstructionsSlice';
import operatorsReducer from './operatorsSlice';
import inputsReducer from './inputsSlice';
import sectionsReducer from './sectionsSlice';
import workflowReducer from './workflowSlice';
import accountReducer from './accountSlice';
import ncractionReducer from './ncractionSlice';
import ncsubtypeReducer from './ncsubtypeSlice';
import nctypeReducer from './nctypeSlice';
import statusReducer from './statusSlice';
import clientReducer from './clientSlice';
import uofmReducer from './uofmSlice';
import eventTypeReducer from './eventTypeSlice';
import machineReducer from './machineSlice';
import operationTypeReducer from './operationTypeSlice';
import shiftsReducer from './shiftsSlice';
import partAttributesReducer from './partAttributesSlice';
import partClassReducer from './partClassSlice';
import partSecAttributesReducer from './partSecAttributesSlice';
import partTercAttributesReducer from './partTercAttributesSlice';
import shipToReducer from './shipToSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  parts: partsReducer,
  purchaseOrder: purchaseOrderReducer,
  workOrder: workOrderReducer,
  routeCard: routeCardReducer,
  packingList: packingListReducer,
  bom: bomReducer,
  product: productReducer,
  component: componentReducer,
  ncr: ncrReducer,
  toolFixture: toolFixtureReducer,
  toolType: toolTypeReducer,
  admin: adminReducer,
  operations: operationsReducer,
  workInstructions: workInstructionsReducer,
  operators: operatorsReducer,
  inputs: inputsReducer,
  sections: sectionsReducer,
  workflow: workflowReducer,
  account: accountReducer,
  ncraction: ncractionReducer,
  ncsubtype: ncsubtypeReducer,
  nctype: nctypeReducer,
  status: statusReducer,
  client: clientReducer,
  uofm: uofmReducer,
  eventType: eventTypeReducer,
  machine: machineReducer,
  operationType: operationTypeReducer,
  shifts: shiftsReducer,
  partAttributes: partAttributesReducer,
  partClass: partClassReducer,
  partSecAttributes: partSecAttributesReducer,
  partTercAttributes: partTercAttributesReducer,
  shipTo: shipToReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
